<div class="webphone-dialer-container">
  <div class="dialer-header">
    <div class="connection-status">
      <span [class.connected]="!(onWebSocketClose$ | async)" [class.disconnected]="onWebSocketClose$ | async">
        {{ !(onWebSocketClose$ | async) ? 'Đã kết nối' : 'Mất kết nối' }}
      </span>
    </div>
  </div>

  <div class="hotline-selector" *ngIf="hotlines.length > 0">
    <div class="hotline-selected" (click)="toggleHotlineDropdown()">
      <div class="hotline-info">
        <div class="hotline-details">
          <span class="hotline-label">Hotline gọi ra</span>
          <span class="hotline-number">{{ selectedHotline?.hotline || 'Chưa chọn' }}</span>
        </div>
      </div>
      <i class="material-icons hotline-arrow" [class.open]="showHotlineDropdown">expand_more</i>
    </div>
    <div class="hotline-dropdown" *ngIf="showHotlineDropdown">
      <div class="hotline-option" *ngFor="let hotline of hotlines" [class.active]="hotline.id === selectedHotline?.id"
        (click)="selectHotline(hotline)">
        <div class="option-info">
          <span class="option-number">{{ hotline.hotline }}</span>
          <span class="option-name" *ngIf="hotline.name">{{ hotline.name }}</span>
        </div>
        <i class="material-icons check-icon" *ngIf="hotline.id === selectedHotline?.id">check</i>
      </div>
    </div>
  </div>

  <div class="phone-number-display">
    <input type="text" class="phone-input" [(ngModel)]="phoneNumber" placeholder="Nhập số điện thoại">
  </div>

  <div class="dialer-pad">
    <div class="dialer-row">
      <button class="dialer-btn" (click)="addDigit('1')" [disabled]="loading">
        <span class="number">1</span>
      </button>
      <button class="dialer-btn" (click)="addDigit('2')" [disabled]="loading">
        <span class="number">2</span>
      </button>
      <button class="dialer-btn" (click)="addDigit('3')" [disabled]="loading">
        <span class="number">3</span>
      </button>
    </div>
    <div class="dialer-row">
      <button class="dialer-btn" (click)="addDigit('4')" [disabled]="loading">
        <span class="number">4</span>
      </button>
      <button class="dialer-btn" (click)="addDigit('5')" [disabled]="loading">
        <span class="number">5</span>
      </button>
      <button class="dialer-btn" (click)="addDigit('6')" [disabled]="loading">
        <span class="number">6</span>
      </button>
    </div>
    <div class="dialer-row">
      <button class="dialer-btn" (click)="addDigit('7')" [disabled]="loading">
        <span class="number">7</span>
      </button>
      <button class="dialer-btn" (click)="addDigit('8')" [disabled]="loading">
        <span class="number">8</span>
      </button>
      <button class="dialer-btn" (click)="addDigit('9')" [disabled]="loading">
        <span class="number">9</span>
      </button>
    </div>
    <div class="dialer-row">
      <button class="dialer-btn contact-btn" (click)="toContactPage()" title="Danh bạ">
        <i class="material-icons">assignment_ind</i>
      </button>
      <button class="dialer-btn" (click)="addDigit('0')" [disabled]="loading">
        <span class="number">0</span>
      </button>
      <button class="dialer-btn backspace-btn" (click)="removeDigit()" [disabled]="!phoneNumber || loading" title="Xóa">
        <i class="material-icons">backspace</i>
      </button>
    </div>
  </div>

  <div class="dialer-actions">
    <button class="action-btn call-btn bg-success text-white" (click)="makeCall()" [disabled]="!phoneNumber || loading" title="Gọi">
      <i class="material-icons">{{ loading ? 'hourglass_empty' : 'call' }}</i>
    </button>
  </div>
</div>